import { ClipboardCopy, Lock, Scale } from "lucide-react";
import Reveal from "@/components/Reveal";

const CHIPS = [
  "Consumer Credit (Card) Debt Buyer Plaintiff",
  "CSEB Confession of Judgment",
  "Post Judgment CM",
  "Article 75 Arbitration",
];

export default function Features() {
  return (
    <section id="features" className="scroll-mt-24 px-5 py-24 md:px-8 md:py-32" data-testid="features-section">
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <p className="mb-4 text-[11px] font-bold uppercase tracking-[0.22em] text-crimson">Features</p>
          <h2 className="max-w-2xl font-display text-4xl leading-[1.1] tracking-tight text-ink md:text-5xl">
            Built for the funding desk and the file room.
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-4 md:grid-cols-3">
          <Reveal className="md:col-span-2" delay={0}>
            <div className="flex h-full flex-col justify-between rounded-lg border border-hairline bg-paper p-8 md:p-10">
              <div>
                <Scale size={20} className="text-crimson" />
                <h3 className="mt-5 font-display text-2xl text-ink md:text-3xl">Spot MCA exposure before you fund</h3>
                <p className="mt-3 max-w-lg text-sm leading-relaxed text-smoke">
                  Filter straight to the case types that matter in merchant cash
                  advance diligence — debt-buyer suits, confessions of judgment
                  and post-judgment matters — before they surface mid-deal.
                </p>
              </div>
              <div className="mt-8 flex flex-wrap gap-2">
                {CHIPS.map((c) => (
                  <span
                    key={c}
                    className="rounded-full border border-black/10 bg-ivory px-3 py-1.5 text-[11px] font-semibold text-ink/70"
                  >
                    {c}
                  </span>
                ))}
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="relative h-full min-h-[320px] overflow-hidden rounded-lg border border-hairline">
              <img
                src="https://images.unsplash.com/photo-1775163024488-e88e4a71179f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHw0fHxsZWdhbCUyMG9mZmljZSUyMHByb2Zlc3Npb25hbHxlbnwwfHx8fDE3OTEzMTgyNzF8MA&ixlib=rb-4.1.0&q=85"
                alt="Professionals reviewing documents at a table"
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 hover:scale-[1.03]"
              />
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-ink/75 to-transparent p-6 pt-16">
                <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-ivory/70">Made for diligence</p>
                <p className="mt-1 font-display text-lg text-ivory">Underwrite with the docket in front of you</p>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0}>
            <div className="h-full rounded-lg border border-hairline bg-paper p-8">
              <p className="font-display text-7xl leading-none text-crimson">62</p>
              <h3 className="mt-5 font-display text-2xl text-ink">Counties, one form</h3>
              <p className="mt-3 text-sm leading-relaxed text-smoke">
                From Kings to Erie, the narrowing panel covers every New York
                county plus statewide — no more retyping the same name sixty
                times.
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="h-full rounded-lg border border-hairline bg-paper p-8">
              <ClipboardCopy size={20} className="text-crimson" />
              <h3 className="mt-5 font-display text-2xl text-ink">Details ride along</h3>
              <p className="mt-3 text-sm leading-relaxed text-smoke">
                Names, county, case type and filing dates are copied to your
                clipboard the moment the court page opens — one paste and the
                court form is done.
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.2}>
            <div className="h-full rounded-lg border border-hairline bg-paper p-8">
              <Lock size={20} className="text-crimson" />
              <h3 className="mt-5 font-display text-2xl text-ink">Nothing stored</h3>
              <p className="mt-3 text-sm leading-relaxed text-smoke">
                Searches run on the court's own public system. DocketScout keeps
                no names, no history and no account file.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
